import type { Dir } from './spatialNav'

export function isVisibleInScrollParents(el: HTMLElement): boolean {
	const r = el.getBoundingClientRect()
	let parent = el.parentElement
	while (parent) {
		const overflow = getComputedStyle(parent).overflow
		if (
			overflow === 'auto' ||
			overflow === 'scroll' ||
			overflow === 'hidden'
		) {
			const pr = parent.getBoundingClientRect()
			if (r.bottom < pr.top + 1 || r.top > pr.bottom - 1) return false
			if (r.right < pr.left + 1 || r.left > pr.right - 1) return false
		}
		parent = parent.parentElement
	}
	return true
}

export function findScrollParent(el: HTMLElement): HTMLElement | null {
	let parent = el.parentElement
	while (parent) {
		const s = getComputedStyle(parent)
		if (
			(s.overflowY === 'auto' || s.overflowY === 'scroll') &&
			parent.scrollHeight > parent.clientHeight
		)
			return parent
		parent = parent.parentElement
	}
	return null
}

function domDistance(a: HTMLElement, b: HTMLElement): number {
	let cur: HTMLElement | null = a
	while (cur) {
		let n = 0
		let walk: HTMLElement | null = b
		while (walk) {
			if (walk === cur) {
				let m = 0
				let wa: HTMLElement | null = a
				while (wa && wa !== cur) {
					wa = wa.parentElement
					m++
				}
				return m + n
			}
			walk = walk.parentElement
			n++
		}
		cur = cur.parentElement
	}
	return 20
}

export function findSpatialTarget(
	source: HTMLElement | null,
	from: DOMRect,
	candidates: HTMLElement[],
	dir: Dir
): HTMLElement | null {
	const isVertical = dir === 'up' || dir === 'down'
	let best: HTMLElement | null = null
	let bestScore = Infinity

	for (const el of candidates) {
		const r = el.getBoundingClientRect()
		if (r.width === 0 && r.height === 0) continue

		let axialDist: number
		if (dir === 'up') axialDist = from.top - r.bottom
		else if (dir === 'down') axialDist = r.top - from.bottom
		else if (dir === 'left') axialDist = from.left - r.right
		else axialDist = r.left - from.right

		if (axialDist < -1) continue
		if (axialDist < 0) axialDist = 0

		const lateralDist = isVertical
			? Math.max(0, from.left - r.right, r.left - from.right)
			: Math.max(0, from.top - r.bottom, r.top - from.bottom)

		const dist = source ? domDistance(source, el) : 0
		const score = (axialDist + lateralDist * 3) * (1 + Math.log1p(dist))
		if (score < bestScore) {
			bestScore = score
			best = el
		}
	}

	return best
}
